import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { SubscriptionTierConfig, UpdateTierInput } from "./types";
import { SUBSCRIPTION_TIERS_QUERY_KEY } from "./constants";

/** `PATCH /api/admin/subscription-tiers/:id` (API-CAP-3). `key` is immutable. */
async function updateTier(id: string, input: UpdateTierInput): Promise<SubscriptionTierConfig> {
  return httpClient<SubscriptionTierConfig>(
    `/api/admin/subscription-tiers/${encodeURIComponent(id)}`,
    {
      method: "PATCH",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(input),
    },
  );
}

export function useUpdateTier(id: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateTierInput) => updateTier(id, input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: SUBSCRIPTION_TIERS_QUERY_KEY });
    },
  });
}
